var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57905 0 0 3.57905 0 8C0 12.4209 3.57905 16 8 16C12.4209 16 16 12.4209 16 8C16 3.57905 12.4169 0 8 0ZM12.303 8.75241H8.75241V12.303C8.75241 12.7178 8.41484 13.0554 8 13.0554C7.58516 13.0554 7.24758 12.7178 7.24758 12.303V8.75241H3.69293C3.27809 8.75241 2.94052 8.41484 2.94052 8C2.94052 7.58516 3.27809 7.24758 3.69293 7.24758H7.24352V3.69293C7.24352 3.27809 7.58109 2.94052 7.99593 2.94052C8.41078 2.94052 8.74835 3.27809 8.74835 3.69293V7.24352H12.2989C12.7138 7.24352 13.0513 7.58109 13.0513 7.99593C13.0513 8.41078 12.7219 8.75241 12.303 8.75241Z",
    fill: "#F8B400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add_new.303317d414301b4671e9b2b8ed2c4fc5.svg";
export { ForwardRef as ReactComponent };